import React from 'react';

/*eslint-disable */

var questionWithCircleFilledIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "20",
    height: "20",
    rx: "10",
    className: "manulifeIconSecondary-fill"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4,9.6 L5.6,9.6 L5.6,12 L2.4,12 L2.4,9.6 Z M4.68928857,0.0722539829 C5.90347427,0.253459606 6.93086218,0.978282099 7.53795503,2.06551584 C8.56534293,3.92287348 7.81815173,6.23324517 5.90347427,7.2298761 C5.62327757,7.36578032 5.43647977,7.63758875 5.38978032,7.90939719 L5.38978032,8 L2.58781331,8 L2.58781331,7.90939719 C2.63451276,6.59565642 3.38170396,5.41781987 4.54919022,4.82890159 C4.96948527,4.60239456 5.20298252,4.1040791 5.10958362,3.65106504 C5.01618472,3.19805098 4.64258912,2.83563974 4.17559461,2.74503693 C4.08219571,2.74503693 4.03549626,2.74503693 3.94209736,2.74503693 C3.33500451,2.74503693 2.82131056,3.24335239 2.82131056,3.83227067 L0.0193435456,3.83227067 C-0.0273559046,3.60576364 0.0193435456,3.3339552 0.0660429958,3.10744817 C0.486338048,1.0235835 2.54111386,-0.335458669 4.68928857,0.0722539829 Z"
  }))));
});

export { questionWithCircleFilledIcon as default };
